<div class="notification_details_container">
  <div [formGroup]="notificationDetailsFilter" class="notif_details_inner_container">
    <div class="modal-header border-0 notif_header">
      <span data-test="notifTitle" class="_title">Updates</span>
      <button data-test="closeButton" mat-icon-button class="close_btn" (click)="closePopover()">
        <i data-test="closeIcon" class="gpr-close"></i>
      </button>
    </div>
    <div class="notif-form-container">
      <div class="date-picker-form">
        <mat-form-field>
          <mat-date-range-input [rangePicker]="picker" data-test="datePicker">
            <input data-test="startDatePickerInput" matStartDate autocomplete="off" formControlName="startDate"
              (focus)="picker.open()">
            <input data-test="endDatePickerInput" matEndDate autocomplete="off" formControlName="endDate"
              (focus)="picker.open()">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconPrefix [for]="picker" data-test="datePickerElement">
            <i data-test="calendarIcon" matDatepickerToggleIcon class="gpr-calendar"></i>
          </mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>

    <div class="modal-body notif_body">
      <section class="table-header-section">
        <table mat-table [dataSource]="displayedColumns" class="details-table header-color">
          <ng-container matColumnDef="productName">
            <th data-test="productName" mat-header-cell *matHeaderCellDef> {{'Product' | uppercase}} </th>
          </ng-container>

          <ng-container matColumnDef="status">
            <th data-test="status" mat-header-cell *matHeaderCellDef> {{'Status' | uppercase}} </th>
          </ng-container>

          <ng-container matColumnDef="elementName">
            <th data-test="elementName" mat-header-cell *matHeaderCellDef> {{('NOTIFICATION.PLACE_IN_CALCULATION' |
              translate) | uppercase}}
            </th>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        </table>
      </section>

      <cdk-virtual-scroll-viewport itemSize="50" class="virtual_scroll_viewport">
        <div *cdkVirtualFor="let notification of notificationDetailedLogs">
          <section class="section-border">
            <table mat-table [dataSource]="notification.changeDetailedLogs"
              [ngClass]="{ 'details-table': true, 'highlight-row': notification.associatedChangeSummaryLogId === scrollChangeSummaryLogId}">
              <ng-container matColumnDef="productName">
                <td mat-cell *matCellDef="let element; let idx = index;">
                  <!-- TODO: need to change in simple way -->
                  <span data-test="changedDate" *ngIf="idx === 0" class="mat-header-cell version_date_span">
                    {{notification.changedDate | date: "dd/MM/yyyy" }} ({{ "NOTIFICATION.REFERENCE_DATE_PRODUCT_DATA" |
                    translate }}: {{ element.previousVersionDate | date: "dd/MM/yyyy" }} -> {{ element.newVersionDate |
                    date: "dd/MM/yyyy" }} | MPG: {{ element.oldTotalMpg | number: ".2-2" }} -> {{ element.newTotalMpg |
                    number: ".2-2" }})<br />
                  </span>
                  <div *ngIf="element.nmdProductName" class="product_name">
                    <div data-test="nmdProductName" #productDescriptionElement class="text-truncate flex-1"
                      container="body" placement="top" [containerClass]="'tooltip_w500'"
                      [tooltip]="element.nmdProductName">
                      {{element.nmdProductName}}
                    </div>
                    <ng-container *ngIf="element.nmdProductDescription">
                      <i class="gpr-info ml-auto" placement="top" tooltip="{{element.nmdProductDescription}}"
                        container="body" [containerClass]="'tooltip_w500'"></i>
                    </ng-container>
                  </div>

                  <ng-template #popTemplate>
                    <span data-test="nmdProductDescription">{{element.nmdProductDescription}}</span>
                  </ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <td data-test="changeTypeId" mat-cell *matCellDef="let element"> {{element.changeTypeId |
                  changeLogStatus}} </td>
              </ng-container>

              <ng-container matColumnDef="description">
                <td data-test="description" mat-cell *matCellDef="let element"> </td>
              </ng-container>

              <ng-container matColumnDef="elementName">
                <td data-test="nmdElementName" mat-cell *matCellDef="let element" [innerHtml]="element.nmdElementName"
                  [class.is_new_notif]="false">
                </td>
              </ng-container>

              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </section>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>

<!-- TODO: We can create separated spinner component -->
<div data-test="loader" *ngIf="isLoaderActive" class="spinner_overlay_container">
  <object class="m-auto" data="../assets/img/gpr-spinner-blocks.svg" height="180px" type="image/svg+xml" width="180px">
    <img data-test="spinner" alt="" class="m-auto" height="180" src="../assets/img/gpr-spinner-blocks.gif" width="180">
  </object>
</div>